import styled from "styled-components";
import { TeaserEmbedProps } from "./TeaserEmbedContainer.types";

export const TeaserEmbed = styled.section<TeaserEmbedProps>`
    background-color: ${(props: { $backgroundcolor: string }) =>props.$backgroundcolor};
    display: block;

    .embed-container{
        width: 100%;

        iframe{
            width: 100%;
            height: 315px;

            @media (min-width: 768px) {
                height: 450px;
            }  
        }

        div{
            display: flex;
            justify-content: center;
            iframe{
                width: 100%;
                height: 379px;

                @media (min-width: 768px) {
                    height: 580px;
                }

                @media (min-width: 1366px) {
                    width: 1366px;
                    height: 580px;

                }
                
            }

        }

    }

`;
